import axios from 'axios'
import store from '@/store/index'
// import router from '@/router'
import jwtManager from '@/store/jwt'

class BaseService {

  constructor() {
    let token = jwtManager.getJwt()
    let service = axios.create({
      headers: {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      }
    })
    service.interceptors.request.use(this.handleSuccessRequest, this.handleErrorRequest)
    service.interceptors.response.use(this.handleSuccessResponse, this.handleErrorResponse)
    this.service = service

    if (
      location.hostname === "localhost" ||
      location.hostname === "127.0.0.1"
    ) {
      this.baseUrl = "https://localhost:5001";
    } else {
      this.baseUrl = "https://vduris.eu/api";
    }
  }

  handleSuccessRequest(config) {
    return config
  }

  handleSuccessResponse(response) {
    return response
  }

  handleErrorRequest = (error) => {
    return Promise.reject(error)
  }

  handleErrorResponse = (error) => {
    if (error.response === undefined) {
      this.showAlert(error)
      return Promise.reject(null)
    }

    switch (error.response.status) {
      case 401:
        this.showAlert('Neautorizovaný prístup!')
        store.dispatch('logout')
        break
      case 404:
        this.showAlert('404')
        break
      default:
        this.showAlert(error.response.data)
        break
    }
    return Promise.reject(error)
  }

  // handleErrorResponse = (response) => {
  //   return response.text().then(text => {
  //     const data = text && JSON.parse(text);
  //     if (!response.ok) {
  //       if ([401, 403, 500].indexOf(response.status) !== -1) {
  //         // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
  //         this.showAlert('Nastala chyba!')
  //         store.dispatch('logout')
  //         location.reload(true);
  //       }

  //       const error = (data && data.message) || response.statusText;
  //       return Promise.reject(error);
  //     }

  //     return data;
  //   });
  // }

  showAlert(message) {
    store.commit('showGlobalAlert', {
      value: true,
      message: message,
      color: 'error'
    })
  }

  logout() {
    store.dispatch('logout').then(() => {
      this.redirectTo(document, '/')
    }).catch(e => {
      console.error(e)
    })
  }

  redirectTo = (document, path) => {
    document.location = path
  }
}

export default BaseService